import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

const FormItem = Form.Item;

const Item = ({
  children, display_name, inputFormItemLayout
}) => (
  <FormItem {...inputFormItemLayout} label={display_name}>
    {children}
  </FormItem>
);

Item.propTypes = {
  children: PropTypes.any.isRequired,
  display_name: PropTypes.string.isRequired,
  inputFormItemLayout: PropTypes.object.isRequired
};

export default Item;
